

import { AxiosRequestHeaders } from 'axios';

import axiosObject from './config';
import { demoActive } from '../demo/core';
import { resolveDemoRequest } from '../demo/api';
// exporting globally.
export { axiosObject } from './config';
export enum HttpMethods {
    POST = "post",
    GET = "get",
    PUT = "put",
    PATCH = "patch",
    DELETE = "delete",
}

export const baseURL = import.meta.env.VITE_API_URL;

export type MakeRequest = {
    url: string;
    method: HttpMethods;
    data?: unknown;
    params?: unknown;
    headers?: AxiosRequestHeaders;
    signal?: AbortSignal;
    onUploadProgress?: any;
};

export const makeRequest = async (req: MakeRequest) => {
    const { url, method, data, params, headers, signal, onUploadProgress } = req;

    // Public demo: answer from the in-memory fake API; nothing reaches the backend.
    if (demoActive()) {
        return resolveDemoRequest({
            url,
            method,
            data,
            params: params as Record<string, unknown> | undefined,
            headers: headers as Record<string, unknown> | undefined,
        });
    }

    return axiosObject({
        url:baseURL + url,
        method,
        data,
        params,
        headers,
        signal,
        onUploadProgress,
    }).then((res) => {
        return res.data;
    });
};
